import APIServer from '@taopix/taopix-core/dist/types/Service/APIServer';
import {AssetMetaInterface} from '@taopix/taopix-core/dist/types/types';

export type SuccessFailList = {
  failed: number[];
  success: number[];
};

export default class AssetHelperService {
  constructor(private server: APIServer) {}

  public onRotateAsset = (asset: AssetMetaInterface): Promise<any> => {
    const {server} = this;
    return new Promise((resolve, reject) => {
      let rotation = asset.rotation - 90;

      if (rotation < 0) {
        rotation += 360;
      }
      server
        .post(
          '/api/assets/rotate',
          {
            assetId: asset.id,
            rotation,
          },
          {
            token: 'token',
            json: true,
          }
        )
        .then(({data}) => resolve(data))
        .catch(error => reject(error));
    });
  };

  /**
   * Remove selected assets from a project
   *
   * @param   {AssetMetaInterface}  asset
   *
   * @return  {Promise<SuccessFailList>}
   */
  public onDeleteAssets = (assets: AssetMetaInterface[]): Promise<SuccessFailList> => {
    const {server} = this;
    return new Promise((resolve, reject) => {
      server
        .post<SuccessFailList>(
          '/api/assets/removeAsset',
          {
            assetIds: assets.map(a => a.id),
          },
          {
            token: 'token',
            json: true,
          }
        )
        .then(({data}) => {
          data.success.forEach(id => {
            PubSub.publish('ASSET_STATS_DELETION', id);
          });
          resolve(data);
        })
        .catch(error => {
          resolve(error);
        });
    });
  };

  /**
   * Clear all assets from a project
   *
   * @return  {Promise<SuccessFailList>
   */
  public onClearAssets = (): Promise<SuccessFailList> => {
    const {server} = this;
    return new Promise((resolve, reject) => {
      server
        .post<SuccessFailList>(
          '/api/assets/clearAssets',
          {},
          {
            json: true,
            token: 'token',
          }
        )
        .then(({data}) => {
          resolve(data);
        })
        .catch(error => {
          reject(error);
        });
    });
  };
}
